import React from 'react';
import { styled, SxProps } from '@mui/material';
import { SlPill } from 'src/components/BeaconV2Components/SlPill';
import color from 'src/utils/colors';

const OuterPill = styled(SlPill)({
  display: 'flex',
  backgroundColor: color.graysPrimary,
  alignItems: 'center',
  gap: '12px',
  padding: '3px 3px 3px 11px',
  height: 'fit-content',
  borderRadius: '24px',
  fontSize: '14px',
  fontWeight: '500 !important'
});

const InnerPill = styled(SlPill)({
  padding: '4px 16px',
  fontSize: '14px',
  borderRadius: '24px',
  fontWeight: '500 !important'
});

interface NestedPillProps {
  text: string | React.ReactNode;
  actionText: string | React.ReactNode;
  onActionClick?: () => void;
  innerPillSx?: SxProps;
  outerPillSx?: SxProps;
  disabled?: boolean;
  hidden?: boolean;
}

const NestedPill: React.FC<NestedPillProps> = ({
  text,
  actionText,
  onActionClick,
  innerPillSx,
  outerPillSx,
  disabled,
  hidden
}) => {
  const getInnerPillSx = () => {
    if (disabled) {
      return {
        ...innerPillSx,
        backgroundColor: color.graysPrimary,
        color: color.blueGrey,
        cursor: 'not-allowed',
      };
    }
    return innerPillSx;
  };

  return (
    <OuterPill sx={outerPillSx} hidden={hidden}>
      {text}
      <InnerPill 
        onClick={disabled ? undefined : onActionClick} 
        selected={!disabled} 
        sx={getInnerPillSx()}
      >
        {actionText}
      </InnerPill>
    </OuterPill>
  );
};

export default NestedPill; 